import heic2any from 'heic2any'

export default async function readEditorImage(file) {
  const isHeif = /\.(heic|heif)$/i.test(file.name || '')
    || /^image\/hei[cf](?:-sequence)?$/i.test(file.type || '')
  if (!isHeif && !/^image\//i.test(file.type || '')
    && !/\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(file.name || '')) {
    throw new Error('Please choose an image file.')
  }

  let image = file
  if (isHeif) {
    const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 })
    image = Array.isArray(converted) ? converted[0] : converted
    if (!image) throw new Error('The image could not be converted.')
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error('The image could not be read.'))
    reader.onabort = () => reject(new Error('Reading the image was cancelled.'))
    reader.readAsDataURL(image)
  })
}
